import { ref } from 'vue';
import StatisticsService from '@/Services/StatisticsService.js';
import { apiClient } from '@/Clients/ApiClient.js';
import { runAsResult } from '@/Utils/AsyncResultUtility';

const statisticsService = new StatisticsService(apiClient);

export const usePlatformStatistics = () => {
    const creatorStatistics = ref({
        usersCount: 0,
        projectsCount: 0,
        ordersValue: 0,
        creatorsCount: 0,
        ordersCount: 0,
    });

    const getStatistics = () => runAsResult(async () => {
        const { data } = await statisticsService.getGlobalApplicationStatistics();
        creatorStatistics.value = data;
        return data;
    });

    return {
        creatorStatistics,
        getStatistics,
    };
};
